import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '@app/features/auth/services/login.service';
import { LoginStateService } from '@app/features/auth/services/login.state.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(
    @Inject('LoginStateService') protected loginStateService: LoginStateService,
    @Inject('LoginService') protected loginService: LoginService,
    private router: Router
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (request.url.includes('api') && !request.url.includes('public')) {
      return next.handle(this.addTokenToRequest(request)).pipe(
        catchError(error => {
          // We check if the filter has rejected the request
          if (error instanceof HttpErrorResponse && error.status === 401) {
            this.loginStateService.closeSession();
            this.router.navigate(['/auth/login']);
            return throwError(error);
          } else {
            // Unknown error, we just throw it
            return throwError(error);
          }
        })
      );
    } else {
      return next.handle(request);
    }
  }

  addTokenToRequest(request: HttpRequest<any>): HttpRequest<any> {
    if (this.loginStateService.isTokenValid()) {
      return request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.loginStateService.getToken()}`
        }
      });
    }
    return request;
  }
}
